<template>
	<div id="detail" class="flex column middle">
    <div style="width:1000px;">
      <crumb :crumb="crumbList"></crumb>
      <div class="section" v-if="trainigInfo">
        <p class="title">{{ trainigInfo.name }}</p>
        <div class="head flex bCenter">
          <div class="base-info flex middle">
            <!-- <span class="title text-overflow">{{ trainigInfo.name }}</span> -->
            <span class="author text-overflow" :title="trainigInfo.course.author">作者：{{ trainigInfo.course?trainigInfo.course.author:'' }}</span>
            <span>截止时间：{{ $utils.myTimeToLocal(trainigInfo.endTime,true) }}</span>
            <span>{{ trainigInfo.userName }}({{ trainigInfo.orgName }})</span>
            <span>发布于：{{ trainigInfo.addTime }}</span>
            <span class="count"><img src="@/assets/images/online-learning/list.png" alt="">{{ trainigInfo.num }}</span>
          </div>
          <!-- <div class="join-btn" v-show="trainigInfo.isMandatory !== 1"> -->
            <!-- <el-button type="primary" size="small" @click="join" v-if="!trainigInfo.isCollect">加入课程</el-button> -->
            <!-- <el-button type="info" size="small"  @click="exit" v-else>退出课程</el-button> -->
          <!-- </div> -->
        </div>
        <div class="foot">
          <div class="introduce container" v-if="trainigInfo.course.courseDesc">
            介绍：{{ trainigInfo.course.courseDesc }}
          </div>
        </div>
      </div>
      <el-container  v-loading="isLoading" element-loading-text="加载中">
        <el-aside>
          <sidebar :sideBarList="sideBarList"></sidebar>
        </el-aside>
        <el-main>
          <router-view :key="key" @reFreash = 'reFreash'></router-view>
        </el-main>
      </el-container>
      <slideverify></slideverify>
    </div>
    </div>
</template>


<script>
import { CloudGetTrainigInfoById, updateStudyTime} from '@/service/api/methods/educationCloud';
import { yjcsUrl } from '@/service/api/httpUrl'

import crumb from '../../components/Crumb/Crumb'
import sidebar from '../../components/SideBar/SideBar'
import slideverify from '../../components/SlideVerify/SlideVerify'
export default {
  components:{
    crumb,
    sidebar,
    slideverify
  },
	data(){
		return{
      yjcsUrl:yjcsUrl,
      //路由地址栏参数
      myIndex : '',
      //获取培训详情
      trainigInfo:null,
      //加载状态
      isLoading:true,
      //菜单栏
      sideBarList:[],
      crumbList:[],
      routerFromInfo:JSON.parse(sessionStorage.getItem('routerFromInfo'))
		}
  },
  watch:{

    //监听防挂机
    '$store.state.preventHangUp.timeHangUp':function(time){
      if( time < 0 ){
        this.$store.commit('OPEN_DIALOG');
        this.$store.commit('RESET_HANGUP');
      }
    },
    //监听路由变化
    '$route':{
      handler(newVal,oldVal){
        //考试和测验停止防挂机计时
          if(newVal.name == 'examtip' || newVal.name == 'beginexam' || newVal.name == 'examDetail' || newVal.name == 'test' || newVal.name == 'detail'){
            this.$store.commit('STOP_HANGUP');
            return
          }else{
            if(this.$utils.getInfo().studyComplete != 1){
              //开始学习记录时间
              this.startStudy();

              //开启防挂机倒计时
              clearInterval(this.timeFuc);
              this.$store.commit('START_HANGUP');
            }
          }
      },
      immidate:true,
      deep:true,
    },
  },
  created(){
    //添加刷新关闭监听事件
    // window.addEventListener('beforeunload', e => this.beforeunloadFn(e));
    this.$nextTick(()=>{
      this.getTrainigInfoById();
    })
    //面包屑导航栏
    this.crumbList = [
      {
        title:this.routerFromInfo.title,
        link:this.routerFromInfo.path
      },
      {
        title:'详情',
      },
    ]
  },
  computed: {
    key() {
      return this.$route.name !== undefined? this.$route.name + +new Date(): this.$route + +new Date()
    },
  },
  methods:{
    //获取培训详情
    getTrainigInfoById(){
      let params ={ id:sessionStorage.getItem('pid') };
      if(this.routerFromInfo.title == '供餐企业管理人员课程'){
        params.type = 2;
      }else if(this.routerFromInfo.title == '从业人员课程'){
        params.type = 3;
      }else if(this.routerFromInfo.title == '宣传视频'){
        params.type = 4;
      }
      CloudGetTrainigInfoById(params).then(
        res=>{
          sessionStorage.setItem('baseUrl',res.baseUrl)
          sessionStorage.setItem('isCourseEnd',res.data.status)
          sessionStorage.setItem('isPass',res.data.isPass);
          this.trainigInfo = res.data;
          if(res.data.course.sectionList.length){
            this.sideBarList = this.newSideBarList(JSON.parse(JSON.stringify(res.data.course.sectionList)));

            //设置默认考试结束倒计时(若未设置时)
            this.$store.commit('SET_TIMER',(Date.parse(new Date(res.data.endTime)) - Date.parse(new Date()))/1000)

            //跳转到指定的学习页面
            // this.$router.push({path:`${this.positionClass(this.sideBarList)}`});
            this.$router.push({path:`/online-learning${this.positionClass(res.data.course.sectionList)}`,query:this.$route.query});
            this.isLoading = false;

            //初始化防挂机倒计时定时器
            this.$store.commit('SET_TIME_HANGUP',res.data.hangupTime*60 || 600);
          }else{
            this.isLoading = false;
          }

        },
      )
    },

    //定位到当前正在学习的章节
    positionClass(tree){
      for(let i in tree){
        if(tree[i].type == 1){//普通有下级的章
          if(tree[i].children.length){
            for(let j in tree[i].children){
              if(tree[i].children[j].studyComplete != 1){//当前课件未完成或正在进行中
                // console.log(tree[i].children[j],1111111111111)
                sessionStorage.setItem('info',JSON.stringify(tree[i].children[j]));
                return this.myIndex = `${this.$utils.lessonTypeUrl(tree[i].children[j].type)}/${i}_${j}_${tree[i].children[j].id}`;
              }else if(tree[i].children[j].studyComplete == 1){//当前课件完成,
                if(tree[i].children[j].complete != 1){//再判断当前课件对应的测验是否完成
                  if(tree[i].children[j].isSetTest == 1){//有测验
                    for(let k in this.sideBarList[i].children){
                      if(this.sideBarList[i].children[k].id == tree[i].children[j].exam.id){
                        // console.log(tree[i].children[j],22222222222)
                        tree[i].children[j].exam.name = tree[i].children[j].name+' - 测验' || ''
                        sessionStorage.setItem('info',JSON.stringify(tree[i].children[j].exam));
                        return this.myIndex = `/test/${i}_${k}_${tree[i].children[j].exam.id}`;
                      }
                    }
                  }
                }
              }
            }
          }else{
            return this.myIndex = `/404/0_0_0`;
          }
        }else if(tree[i].type == 2){//课件无下级的章
          if(this.$utils.isArrayEmpty(tree[i].children)){
            if(tree[i].complete != 1){
              if(tree[i].isSetTest == 1){
                if(tree[i].studyComplete ==1){
                  //测验
                  // console.log(tree[i],7894)
                  tree[i].exam.name = tree[i].name+' - 测验' || ''
                  sessionStorage.setItem('info',JSON.stringify(tree[i].exam));
                  return this.myIndex = `/test/${i}_${1}_${tree[i].exam.id}`;
                }else{
                  //课件
                  // console.log(6666666)
                  sessionStorage.setItem('info',JSON.stringify(tree[i]));
                  return this.myIndex = `${this.$utils.lessonTypeUrl(tree[i].type)}/${i}_${0}_${tree[i].id}`;
                }
              }else{//有课件无测验
                // console.log(tree[i],11111)
                sessionStorage.setItem('info',JSON.stringify(tree[i]));
                return this.myIndex = `${this.$utils.lessonTypeUrl(tree[i].type)}/${i}_${0}_${tree[i].id}`;
              }
            }else{
              if(tree[i].isSetTest != 1){
                if(tree[i].complete != 1){
                  // console.log(tree[i],777777)
                  sessionStorage.setItem('info',JSON.stringify(tree[i]));
                  return this.myIndex = `${this.$utils.lessonTypeUrl(tree[i].type)}/${i}_${0}_${tree[i].id}`;
                }
              }
            }
          }else{
            for(let j in tree[i].children){
              if(tree[i].children[j].complete != 1){
                if(tree[i].children[j].studyComplete == 1){
                  if(tree[i].isSetTest == 1){//设置了课件考试
                    // console.log(tree[i].children[j],33333333333)
                    tree[i].children[j].exam.name = tree[i].children[j].name+' - 测验' || ''
                    sessionStorage.setItem('info',JSON.stringify(tree[i].children[j].exam));
                    return this.myIndex = `/test/${i}_${Number(j)+1}_${tree[i].children[j].exam.id}`;
                  }
                }else{
                  // console.log(tree[i].children[j],444444444444)
                  sessionStorage.setItem('info',JSON.stringify(tree[i].children[j]));
                  return this.myIndex = `${this.$utils.lessonTypeUrl(tree[i].children[j].type)}/${i}_${j}_${tree[i].children[j].id}`;
                }
              }
            }
          }
        }else{
          //考试
          sessionStorage.setItem('info',JSON.stringify(tree[tree.length-1]));
          return this.myIndex = `${this.$utils.lessonTypeUrl(tree[tree.length-1].type)}/${tree.length-1}_0_${tree[tree.length-1].id}`
        }
      }
      // 执行到此，表示所有章节已经学习完成
      for(let i in tree){
        if(tree[i].type == 1){
          // console.log(tree[i],7845)
          sessionStorage.setItem('info',JSON.stringify(tree[i].children[0]));
          return this.myIndex = `${this.$utils.lessonTypeUrl(tree[i].children[0].type)}/${i}_${0}_${tree[i].children[0].id}`;
        }else if(tree[i].type == 2){
          if(!this.$utils.isArrayEmpty(tree[i].attchList)){//有课件
            // console.log(13487)
            sessionStorage.setItem('info',JSON.stringify(tree[i]));
            return this.myIndex = `${this.$utils.lessonTypeUrl(tree[i].type)}/${i}_${0}_${tree[i].id}`;
          }else{
            // console.log(784512)
            sessionStorage.setItem('info',JSON.stringify(tree[i]));
            return this.myIndex = `/404/${i}_${0}_${tree[i].id}`;
          }
        }
      }
    },

    //开始学习
    startStudy(){
      if(this.$route.name == 'examtip' || this.$route.name == 'beginexam' || this.$route.name == 'examDetail' || this.$route.name == 'test'){
        return
      }
      //判断是否已经加入课程，未加入不计算学习时间
      if(sessionStorage.getItem('isCourseEnd') == 3 || !sessionStorage.getItem('isCourseEnd')){
        return
      }
      //是否设置上一章节完成才能学习下一章节
      if(sessionStorage.getItem('isPass') && Number(sessionStorage.getItem('isPass'))){
        if(this.$route.params.id && this.$route.params.id.split('_')[0]>0){
          if(!this.$utils.isArrayEmpty(this.sideBarList[this.$route.params.id.split('_')[0]-1].children)){
            let arr = this.sideBarList[this.$route.params.id.split('_')[0]-1].children.filter((item=>{
              return item.complete == -1 || item.complete == 0
            }))
            if(!this.$utils.isArrayEmpty(arr)){
              return
            }
          }
        }
      }
      // if(this.trainigInfo.isCollect || this.trainigInfo.isMandatory){
      //   if(this.$utils.getInfo().objectiveQuesList){
      //     return
      //   }
      //   let params = {
      //     beginTime : Date.parse(new Date()),
      //     courseid:this.trainigInfo.course.id,
      //     sectionid:this.$utils.getInfo().id,
      //   };
      //   this.$utils.beginStudy();
      //   // console.log('开始学习1')
      //   startStudy(params).then(
      //     res=>{
      //       if(this.$route.name == '404' || this.$route.name == 'picture' || this.$route.name == 'documentDetails'){
      //         let params = {
      //           sectionid:this.$utils.getInfo().id,
      //           isComplete:1,
      //           duration:1,
      //         }
      //         updateStudyTime(params).then(
      //           res=>{
      //             CloudGetTrainigInfoById({ id:this.$utils.getPid() }).then(
      //               res=>{
      //                 this.sideBarList = this.newSideBarList(JSON.parse(JSON.stringify(res.data.course.sectionList)))
      //               }
      //             )
      //           }
      //         );
      //       }

      //     }
      //   );
      // }else{
      //   if(this.$route.name != 'examtip' || this.$route.name != 'beginexam' || this.$route.name != 'examDetail' || this.$route.name != 'test'){
      //     this.$message({
      //       type:'warning',
      //       message:'注意：未加入课程，学习时间将不做记录',
      //       center:true,
      //     })
      //   }
      // }
    },
    //重新组装后台数据sectionList数据传给sidebar
    newSideBarList(data){
      let i = 1;
      data.map((item,index)=>{
        if(item.type == 1){
          if(item.children.length){
            let children = [];
            item.children.map((citem,cindex)=>{
              if(citem.isSetTest == 1){
                citem.exam.name = `${citem.name || ''} - 测验`;
                if(citem.complete == 1){
                  citem.exam.examRet = 1;
                }
                children.push(citem)
                children.push(citem.exam)
              }else{
                children.push(citem)
              }
              item.children = children;
              delete citem.exam;
            })
          }
        }else if( item.type == 2 ){
          if( item.isSetTest === 1 ){
            //课件目录有测验
            item.exam.name = `${item.name || ''} - 测验`;
            if(item.complete == 1){
              item.exam.examRet = 1;
            }
            let arr = [],
              obj = JSON.parse(JSON.stringify(item))
            arr[1] = obj.exam;
            delete obj.children;
            delete obj.exam;
            arr[0] = obj;
            item.children = arr;
          }
          else{
            //课件目录无测验
            if(!this.$utils.isArrayEmpty(item.attchList)){
              let children = [],
                  obj = JSON.parse(JSON.stringify(item))
              obj.attchList[0].type = 2;
              delete obj.children;
              item.children = [obj];
            }
          }
        }
      })
      return data;
    },

    //测验查看测验结果更新菜单状态
    reFreash(){
      CloudGetTrainigInfoById({ id:this.$utils.getPid() }).then(
        res=>{
          this.sideBarList = this.newSideBarList(JSON.parse(JSON.stringify(res.data.course.sectionList)))
        }
      )
    },

    //刷新-关闭浏览器事件
    beforeunloadFn (e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = '关闭提示';
      }
      localStorage.setItem('studyBtime',JSON.parse(Date.parse(new Date())))
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      e.returnValue = '关闭提示';

    },
    //更新学习时间
    myUpdateStudyTime(isComplete){
      if(this.$utils.studyTime()<0 || !this.$utils.getInfo().id || sessionStorage.getItem('isCourseEnd') == 3 || !sessionStorage.getItem('isCourseEnd')){
        return
      }
      let params = {
        sectionid:this.$utils.getInfo().id,
        isComplete:isComplete,
        duration:this.$utils.studyTime(),
      }
      updateStudyTime(params)
      // console.log('updateTime22222')

    }
  },
  beforeDestroy() {
    //离开学习记录时间
    this.$utils.endStudy();
  },
  destroyed() {
    //停止防挂机倒计时
    this.$store.commit('STOP_HANGUP')
    //取消事件绑定
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  }
}
</script>

<style lang="less" scoped>
@import './Detail.less';
</style>

